import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { EmploymentModel } from 'src/app/model/employer.model';

export const RequestAction = createAction('[Employer Balances] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Employer Balances] set data', props<{ payload: EmploymentModel[] }>());
